<template>
  <v-container>
    <v-row>
      <v-col cols="8">
        <v-card class="pa-4">
          <v-tabs v-model="tab">
            <v-tab>
              Empresa
            </v-tab>
            <v-tab>
              Cliente
            </v-tab>
            <v-tab>
              Productos
            </v-tab>
            <v-tab>
              Venta
            </v-tab>
            <v-tab>
              Factura
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" class="mt-4">
            <v-tab-item>
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    label="Nombre o Razon Social"
                    v-model="obj.empresa.nombre"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    label="Descripcion"
                    v-model="obj.empresa.descripcion"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    label="Contacto"
                    v-model="obj.empresa.contacto"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Direccion"
                    v-model="obj.empresa.direccion"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Localidad"
                    v-model="obj.empresa.localidad"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    label="Responsabilidad IVA"
                    v-model="obj.empresa.iva"
                    :items="responsabilidadIVA"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="CUIT"
                    v-model="obj.empresa.cuit"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Ingresos Brutos"
                    v-model="obj.empresa.ib"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-menu
                    ref="menuInicioActividad"
                    v-model="menuInicioActividad"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="obj.empresa.inicio"
                        label="Inicio de Actividades"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="obj.empresa.inicio"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @change="guardarFecha"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    label="Nombre o Razon Social"
                    v-model="obj.cliente.nombre"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Domicilio"
                    v-model="obj.cliente.domicilio"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    label="Responsabilidad IVA"
                    v-model="obj.cliente.iva"
                    :items="responsabilidadIVA"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="3">
                  <v-autocomplete
                    label="Tipo de Documento"
                    v-model="obj.cliente.tipoDoc"
                    :items="tiposDocumento"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="N° de Documento"
                    v-model="obj.cliente.doc"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Codigo
                      </th>
                      <th class="text-left">
                        Descripcion
                      </th>
                      <th class="text-left">
                        Cantidad
                      </th>
                      <th class="text-left">
                        Precio Unitario
                      </th>
                      <th class="text-left">
                        Alicuota IVA
                      </th>
                      <th class="text-left">
                        Precio Incluye IVA
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in obj.productos" :key="index">
                      <td>
                        <v-text-field
                          v-model="obj.productos[index].codigo"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="obj.productos[index].descripcion"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="obj.productos[index].cantidad"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="obj.productos[index].precioUnitario"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-autocomplete
                          v-model="obj.productos[index].alicuotaIVA"
                          :items="alicuotasIVA"
                        ></v-autocomplete>
                      </td>
                      <td>
                        <v-checkbox
                          v-model="obj.productos[index].incluyeIVA"
                        ></v-checkbox>
                      </td>
                      <td>
                        <v-btn icon @click="quitarProducto(index)"
                          ><v-icon>mdi-delete</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <span v-if="obj.productos.length == 0"
                >No hay elementos para mostrar.</span
              >
              <v-btn
                block
                color="green"
                dark
                class="mt-2"
                @click="agregarProducto"
                >Agregar producto</v-btn
              >
            </v-tab-item>
            <v-tab-item>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    label="Condicion de Venta"
                    v-model="obj.venta.condicion"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Punto de Venta"
                    v-model="obj.venta.ptoVta"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    label="Tipo de Comprobante"
                    v-model="obj.factura.tipo"
                    :items="tiposComprobante"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6"
                  ><v-text-field
                    label="N° de Comprobante"
                    v-model="obj.factura.numero"
                  ></v-text-field
                ></v-col>
                <v-col cols="6"
                  ><v-menu
                    ref="menuFechaEmision"
                    v-model="menuFechaEmision"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="obj.factura.emision"
                        label="Fecha Emision de Factura"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="obj.factura.emision"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @change="guardarFechaEmision"
                    ></v-date-picker> </v-menu
                ></v-col>
                <v-col cols="6"
                  ><v-menu
                    ref="menuFechaVenc"
                    v-model="menuFechaVenc"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="obj.factura.vencimiento"
                        label="Fecha Emision de Factura"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="obj.factura.vencimiento"
                      min="1950-01-01"
                      @change="guardarFechaVencimiento"
                    ></v-date-picker> </v-menu
                ></v-col>
                <v-col cols="12">
                  <v-text-field
                    label="N° de CAE"
                    v-model="obj.factura.cae"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
      <v-col cols="4"
        >
        <v-alert type="info" outlined>POST https://fe.nubi.dev/api</v-alert>
        <v-textarea
          solo
          class="caption"
          :value="objJson"
          readonly
          rows="10"
        ></v-textarea>
        <v-btn block color="primary" @click="generarPDF()" :loading="loading"
          >GENERAR PDF</v-btn
        ></v-col
      >
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HelloWorld",
  data: () => ({
    tab: 0,
    menuInicioActividad: 0,
    menuFechaEmision: 0,
    menuFechaVenc: 0,
    loading: false,
    responsabilidadIVA: [
      {
        text: "(1) Responsable Inscripto",
        value: 1,
      },
      {
        text: "(2) Responsable No Inscripto",
        value: 2,
      },
      {
        text: "(3) IVA No Responsable",
        value: 3,
      },
      {
        text: "(4) IVA Exento",
        value: 4,
      },
      {
        text: "(5) Consumidor Final",
        value: 5,
      },
      {
        text: "(6) Responsable Monotributo",
        value: 6,
      },
      {
        text: "(13) Monotributista Social",
        value: 13,
      },
    ],
    tiposDocumento: [
      {
        text: "(80) CUIT",
        value: 80,
      },
      {
        text: "(96) DNI",
        value: 96,
      },
      {
        text: "(86) CUIL",
        value: 86,
      },
      {
        text: "(91) CI EXTRANJERO",
        value: 91,
      },
      {
        text: "(94) PASAPORTE",
        value: 94,
      },
      {
        text: "(99) CONSUMIDOR FINAL",
        value: 99,
      },
    ],
    tiposComprobante: [
      {
        text: "(1) FACTURA A",
        value: 1,
      },
      {
        text: "(99) FACTURA B",
        value: 6,
      },
      {
        text: "(11) FACTURA C",
        value: 11,
      },
      {
        text: "(99) PRESUPUESTO",
        value: 99,
      },
    ],
    alicuotasIVA: [21, 10.5, 0],
    // obj: {
    //   empresa: {
    //     nombre: "",
    //     descripcion: "",
    //     direccion: "",
    //     localidad: "",
    //     contacto: "",
    //     iva: 1,
    //     cuit: 0,
    //     ib: 0,
    //     inicio: null,
    //   },
    //   cliente: {
    //     nombre: "",
    //     domicilio: "",
    //     doc: 0,
    //     tipoDoc: 99,
    //     iva: 5,
    //   },
    //   venta: {
    //     condicion: "Contado",
    //     ptoVta: 1,
    //   },
    //   productos: [],
    //   factura: {
    //     tipo: 1,
    //     cae: 0,
    //     vencimiento: null,
    //     numero: 1,
    //     emision: null,
    //   },
    // },
    obj: {
      empresa: {
        nombre: "nubidev",
        descripcion: "Consultoria IT",
        direccion: "H. Irigoyen 2440 6",
        localidad: "Corrientes, Corrientes CP 3400",
        contacto: 3794149941,
        iva: 6,
        cuit: 20369592298,
        ib: 20369592298,
        inicio: "2021-01-01",
      },
      cliente: {
        nombre: "Consumidor Final",
        domicilio: "H. Irigoyen 2440 6",
        doc: 99999999,
        tipoDoc: 99,
        iva: 5,
      },
      venta: {
        condicion: "Contado",
        ptoVta: 1,
      },
      productos: [
        {
          codigo: "1000",
          descripcion: "SERV. DESARROLLO",
          cantidad: 1,
          precioUnitario: 3000,
          alicuotaIVA: 21,
          incluyeIVA: true, // true = el precio incluye el IVA, false = el precio NO incluye IVA
        },
      ],
      factura: {
        tipo: 11,
        cae: 68493708124615,
        vencimiento: "2022-01-31",
        numero: 1,
        emision: "2021-01-31",
      },
    },
  }),
  computed: {
    objJson() {
      return JSON.stringify(this.obj);
    },
  },
  methods: {
    guardarFecha(date) {
      this.$refs.menuInicioActividad.save(date);
    },
    guardarFechaEmision(date) {
      this.$refs.menuFechaEmision.save(date);
    },
    guardarFechaVencimiento(date) {
      this.$refs.menuFechaVenc.save(date);
    },
    quitarProducto(i) {
      this.obj.productos.splice(i, 1);
    },
    agregarProducto() {
      this.obj.productos.push({
        codigo: "",
        descripcion: "",
        cantidad: 1,
        precioUnitario: 0,
        alicuotaIVA: 21,
        incluyeIVA: true, // true = el precio incluye el IVA, false = el precio NO incluye IVA
      });
    },
    async generarPDF() {
      this.loading = true;
      try {
        let pdf = await this.axios.post("/api", this.obj, {
          responseType: "blob",
        });
        var blob = new Blob([pdf.data], { type: "application/pdf" });
        var link = window.URL.createObjectURL(blob);
        window.open(link, "", "height=650,width=840");
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
  },
  created() {},
};
</script>
